import React from 'react'

import MemoNotificationsOutlined from '../Icons/NotificationsOutlined'
import { Badge, IconButton } from '../../../components'
import { useNotificationsHomeContext } from '../../context'
import { useTheme } from '../../../hooks/useTheme'

export const NotificationsButton = () => {
  const {
    data: {
      isSeen,
      customNotificationIconComponent,
      unreadList,
      isNotificationCenterOpen
    },
    handlers: { handleOpenPanel, handleClosePanel }
  } = useNotificationsHomeContext()

  const theme = useTheme()

  const handleToggleNotificationCenter = (e) => {
    if (isNotificationCenterOpen) {
      handleClosePanel(e)
    } else {
      handleOpenPanel(e)
    }
  }

  return (
    <IconButton onClick={(e) => handleToggleNotificationCenter(e)}>
      <Badge
        color='error'
        overlap='circular'
        variant='dot'
        invisible={isSeen}
        badgeContent={Array?.isArray(unreadList) ? unreadList?.length : 0}
      >
        {customNotificationIconComponent || (
          <MemoNotificationsOutlined color={theme?.palette?.text?.secondary} />
        )}
      </Badge>
    </IconButton>
  )
}

export default NotificationsButton
